import {DocRenderer} from '@cyntler/react-doc-viewer';
import React from 'react';
import PDFViewer from '../CustomViewers/PDFViewer';
import PDFFilecabinetViewer from '../CustomViewers/NewPDFViewer';

const ReactPDFRenderer: DocRenderer = ({mainState: {currentDocument}}) => {
  if (currentDocument?.uri?.length) {
    try {
      return (
        <div
          style={{
            flex: 1,
            justifyContent: 'center'
          }}>
          <PDFFilecabinetViewer buffer={currentDocument?.uri ?? ''} />
        </div>
      );
    } catch (error) {
      console.error('Error decoding Base64 string:', error);
      return <div>Error loading PDF viewer</div>;
    }
  } else {
    return <div>Loading...</div>;
  }
};

ReactPDFRenderer.fileTypes = ['pdf', 'application/pdf'];
ReactPDFRenderer.weight = 1;

export default ReactPDFRenderer;
